var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_302_309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 0C8.06039 0 0 7.83649 0 17.5C0 27.1635 8.06039 35 18 35C27.9396 35 36 27.1635 36 17.5C36 7.83649 27.9396 0 18 0ZM12.7694 26.4551H8.38559V13.6326H12.7694V26.4551ZM10.5776 11.8817H10.5491C9.078 11.8817 8.12659 10.8972 8.12659 9.66671C8.12659 8.40847 9.10712 7.45117 10.6068 7.45117C12.1064 7.45117 13.0292 8.40847 13.0578 9.66671C13.0578 10.8972 12.1064 11.8817 10.5776 11.8817ZM28.5765 26.4551H24.1933V19.5954C24.1933 17.8714 23.5585 16.6957 21.9724 16.6957C20.7614 16.6957 20.0402 17.4888 19.7232 18.2544C19.6073 18.5283 19.579 18.9112 19.579 19.2944V26.4551H15.1955C15.1955 26.4551 15.2529 14.8356 15.1955 13.6326H19.579V15.4482C20.1616 14.5744 21.2039 13.3317 23.5297 13.3317C26.4139 13.3317 28.5765 15.1643 28.5765 19.1027V26.4551Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_302_309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.04a29d8c3e7152290852f8197f2fe040.svg";
export { ForwardRef as ReactComponent };